import React from 'react';
import { Text } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";

var Description = function Description(props) {
  return /*#__PURE__*/_jsx(Text, {
    $variant: "p1",
    $align: "center",
    $mx: "auto",
    $styles: {
      maxWidth: [null, 800, 800, 800],
      opacity: 'var(--wcds-legacy-paragraph-opacity)' // to be removed when VIS is the default theme

    },
    children: props.children
  });
};

export default Description;